import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";

export default function ChannelChart({ data }) {
  return (
    <div style={{ width: "100%", height: 360 }}>
      <ResponsiveContainer>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="source" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="pageViews" name="Page Views" fill="#1677ff" />
          <Bar dataKey="whatsappClicks" name="Cliques WhatsApp" fill="#52c41a" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}